export type CartAddPayload = {
  id: string
  quantity: number
  properties?: Record<string, string>
}

export function formDataToCartAddPayload(formData: FormData): CartAddPayload {
  const properties: Record<string, string> = {}
  let id = ''
  let quantity = 1

  for (const [key, value] of formData.entries()) {
    if (typeof value !== 'string') continue

    if (key === 'id') {
      id = value
      continue
    }

    if (key === 'quantity') {
      quantity = Number(value) || 1
      continue
    }

    const propertyMatch = key.match(/^properties\[(.+)\]$/)
    if (propertyMatch) {
      properties[propertyMatch[1]] = value
    }
  }

  return {
    id,
    quantity,
    ...(Object.keys(properties).length > 0 ? { properties } : {}),
  }
}
